export default "__VITE_ASSET__BvOz1odJ__"